import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Rectangles = ({ className }) => {
  return (
    <svg
      viewBox='0 0 42 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-rectangles', { [className]: className })}
    >
      <path d='M5.78943 0H0.5V19.9998H5.78943V0Z' fill='currentColor' />
      <path d='M16.3676 0H11.0781V19.9998H16.3676V0Z' fill='currentColor' />
      <path d='M26.9457 0H21.6562V19.9998H26.9457V0Z' fill='currentColor' />
      <path
        d='M41.5005 0.00292969L37.2768 19.9999H31.8594L36.0831 0.00292969H41.5005Z'
        fill='currentColor'
      />
    </svg>
  );
};

Rectangles.propTypes = {
  className: PropTypes.string,
};

export default Rectangles;
